module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo4-36b7d7535694659dab960f46dbb7eebb.jpg";